// Cupo de análisis con IA: cuando se agota, el usuario amplía SOLO, sin escribirle
// a nadie. Regla del modelo: el overage es autogestionable y de un clic.
//
// Se usa donde una acción de IA falla con `reason === 'cupo'`:
//   if (res.reason === 'cupo' && await ofrecerPaqueteIA(res.detalle)) { /* reintentar */ }
import { supabase } from '../db/engine';

const PAQUETE_TXT = '50 análisis por B/. 7.00';

// Muestra la confirmación y, si acepta, compra el paquete.
// Devuelve true si el cupo quedó ampliado (el llamador puede reintentar la acción).
export async function ofrecerPaqueteIA(mensajeServidor) {
  const base = mensajeServidor || 'Llegaste al límite de análisis con IA de tu plan este mes.';
  const ok = window.confirm(
    `${base}\n\n` +
    `¿Agregar ${PAQUETE_TXT} a tu próxima factura?\n\n` +
    `Se amplía al instante y sigues trabajando.`
  );
  if (!ok) return false;

  try {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session?.access_token) { alert('Tu sesión expiró. Vuelve a iniciar sesión.'); return false; }
    const r = await fetch('/api/ia-paquete', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${session.access_token}` },
      body: JSON.stringify({}),
    });
    const res = await r.json().catch(() => ({}));
    if (!r.ok || !res.ok) {
      // El motivo SIEMPRE se muestra (ej. "solo un master puede ampliar el cupo").
      alert(res.error || 'No se pudo ampliar el cupo. Intenta de nuevo.');
      return false;
    }
    alert(`✓ Listo: +${res.agregados} análisis.\n\nLlevas ${res.usados} de ${res.limite} este mes (${res.disponibles} disponibles). El cargo entra en tu próxima factura.`);
    return true;
  } catch (e) {
    alert('No se pudo ampliar el cupo: ' + (e.message || ''));
    return false;
  }
}
